import '../../style/base.css';
import '../../loading/index.css';
import '../../picker/index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/datetime-picker/style/index.js
// module id = 408
// module chunks = 0